<script setup>
import InfoText from '../dashboard/InfoText.vue';
import { getRegion } from '../../helpers.js';
</script>

<template>
    <section class="section-white container mx-auto max-w-5xl">
        <div class="text-center mb-6">
            <p class="uppercase text-sm">{{ $t('howToProtectYourself.protectSubtitle') }}</p>
            <h2 class="text-2xl font-bold uppercase">{{ $t('howToProtectYourself.protectHeading') }}</h2>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-14">
            <div>
                <div class="flex items-center">
                    <i class="fi fi-ss-octagon-exclamation text-6xl text-red flex-shrink-0 mr-2"></i>
                    <h3 class="text-lg font-semibold uppercase leading-none relative -top-1">
                        {{ $t('howToProtectYourself.neverTitle') }}
                    </h3>
                </div>
                <ul class="list-disc list-outside space-y-2 pl-11">
                    <li>{{ $t('howToProtectYourself.neverItem1') }}</li>
                    <li>
                        {{ $t('howToProtectYourself.neverItem2') }}
                        <InfoText class="inline-block align-text-bottom ml-2" :text="$t('howToProtectYourself.neverItem2Info')" />
                    </li>
                    <li>{{ $t('howToProtectYourself.neverItem3') }}</li>
                    <li>{{ $t('howToProtectYourself.neverItem4') }}</li>
                    <li>
                        {{ $t('howToProtectYourself.neverItem5') }}
                        <InfoText class="inline-block align-text-bottom ml-2" :text="$t('howToProtectYourself.neverItem5Info')" />
                    </li>
                    <li>{{ $t('howToProtectYourself.neverItem6') }}</li>
                    <li>{{ $t('howToProtectYourself.neverItem7') }}</li>
                </ul>
            </div>
            <div>
                <div class="flex items-center">
                    <i class="fi fi-ss-shield-check text-6xl text-green mr-2 flex-shrink-0"></i>
                    <h3 class="text-lg font-semibold uppercase leading-none relative -top-1">
                        {{ $t('howToProtectYourself.officialTitle') }}
                    </h3>
                </div>
                <ul class="list-disc list-outside space-y-2 pl-11">
                    <li class="hover:underline">
                        <router-link :to="{ path: '/' }">{{ $t('howToProtectYourself.officialWebsite') }}</router-link>
                    </li>
                    <li>
                        <span>{{ $t('howToProtectYourself.officialAppLabel') }}</span>
                        <div class="flex-row gap-4 mt-1">
                            <div class="flex w-full justify-start gap-2">
                                <a href="https://apps.apple.com/de/app/hkcm/id6499010943" class="h-auto" target="_blank">
                                    <img
                                        alt="Apple Store"
                                        class="object-contain max-h-[40px] hover:opacity-80 transition-opacity"
                                        :src="$asset(getRegion === 'de' ? '/hkcm/images/apple-store-badge.png' : '/hkcm/images/apple-store-badge-en.png')"
                                    />
                                </a>
                                <a href="https://play.google.com/store/apps/details?id=de.hkcm.app&hl=de&pli=1" class="h-auto" target="_blank">
                                    <img
                                        alt="Google Play Store"
                                        class="object-contain max-h-[40px] hover:opacity-80 transition-opacity"
                                        :src="$asset(getRegion === 'de' ? '/hkcm/images/google-play-badge.png' : '/hkcm/images/google-play-badge-en.png')"
                                    />
                                </a>
                            </div>
                        </div>
                    </li>
                    <li class="hover:underline">
                        <router-link :to="{ hash: '#social-media-channels' }">
                            {{ $t('howToProtectYourself.officialSocialMedia') }}
                        </router-link>
                    </li>
                    <li class="hover:underline">
                        <router-link :to="{ path: '/produkte' }">
                            {{ $t('howToProtectYourself.officialAnalyses') }}
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>
